<div
  id="demo-user-setup-modal"
  [attr.data-cy]="'demo-setup-step-' + (currentStep$ | async)">
  <!-- Welcome Step -->
  <ng-container *ngIf="(currentStep$ | async) === DemoUserSetupStep.WELCOME">
    <div
      class="step-container"
      data-cy="welcome-step">
      <h1 data-cy="welcome-title">{{ "welcomeTitle" | i18n }}</h1>
      <p
        class="description-text"
        data-cy="welcome-text">
        {{ "welcomeTextDemoUserSetup" | i18n }}
      </p>
      <p
        class="description-text"
        data-cy="welcome-text-2">
        {{ "welcomeTextDemoUserSetup2" | i18n }}
      </p>
      <p
        class="description-text"
        data-cy="welcome-text-3">
        {{ "welcomeTextDemoUserSetup3" | i18n }}
      </p>
      <div class="step-actions">
        <button
          class="primary-pill-button icon-right"
          (click)="nextStep()"
          type="button"
          data-cy="next-button">
          {{ "continue" | i18n }}
          <mat-icon svgIcon="chevron-right"></mat-icon>
        </button>
      </div>
    </div>
  </ng-container>

  <!-- User Form Step -->
  <ng-container *ngIf="(currentStep$ | async) === DemoUserSetupStep.USER_FORM">
    <div
      class="step-container"
      data-cy="user-form-step">
      <h1 data-cy="user-form-title">
        {{ "userFormTitle" | i18n }}
      </h1>

      <form [formGroup]="userForm">
        <app-sex-select
          formControlName="sex"
          class="light-form-field"
          [isRequired]="true"
          [useSalutation]="true">
        </app-sex-select>

        <mat-form-field class="light-form-field">
          <mat-label>{{ "firstName" | i18n }}</mat-label>
          <input
            matInput
            formControlName="firstName"
            name="firstName"
            type="text"
            required
            data-cy="first-name-input" />
        </mat-form-field>

        <mat-form-field class="light-form-field">
          <mat-label>{{ "lastName" | i18n }}</mat-label>
          <input
            matInput
            formControlName="lastName"
            name="lastName"
            type="text"
            required
            data-cy="last-name-input" />
        </mat-form-field>

        <mat-form-field class="light-form-field">
          <mat-label>{{ "businessEmailLabel" | i18n }}</mat-label>
          <input
            matInput
            formControlName="email"
            name="email"
            type="email"
            required
            pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}"
            data-cy="email-input" />
        </mat-form-field>

        <mat-form-field class="light-form-field">
          <mat-label>{{ "phone" | i18n }}</mat-label>
          <input
            matInput
            formControlName="phone"
            name="phone"
            type="tel"
            required
            placeholder="+41791234567"
            pattern="\+?[1-9]\d{0,14}"
            (keyup)="trimPhone()"
            autocomplete="tel"
            data-cy="phone-input" />
        </mat-form-field>

        <ng-container *ngIf="validationState$ | async as validationState">
          <div
            *ngIf="validationState.emailExistsError"
            class="validation-warning"
            data-cy="email-exists-error">
            <mat-icon
              svgIcon="alert-outline"
              class="size-20"></mat-icon>
            <span
              [innerHTML]="
                'demoEmailExistsAlreadyError' | i18n: { email: email || '' }
              "></span>
          </div>
          <div
            *ngIf="
              validationState.showValidationError &&
              !validationState.emailExistsError
            "
            class="validation-warning"
            data-cy="validation-warning">
            <mat-icon
              svgIcon="alert-outline"
              class="size-20"></mat-icon>
            <span>{{ "checkYourData" | i18n }}</span>
          </div>
        </ng-container>
        <div class="step-actions">
          <button
            class="outline-pill-button"
            (click)="closeModal()"
            type="button"
            data-cy="cancel-user-button">
            {{ ("cancel" | i18n) || "Abbrechen" }}
          </button>
          <button
            class="primary-pill-button icon-right"
            (click)="submitUserForm()"
            type="button"
            data-cy="submit-user-button">
            {{ "submitUserButton" | i18n }}
            <mat-icon svgIcon="chevron-right"></mat-icon>
          </button>
        </div>
      </form>
    </div>
  </ng-container>

  <!-- Confirm Email Step -->
  <ng-container
    *ngIf="(currentStep$ | async) === DemoUserSetupStep.CONFIRM_EMAIL">
    <div
      class="step-container"
      data-cy="confirm-email-step">
      <h1 data-cy="confirm-email-title">
        {{ "confirmEmailTitle" | i18n }}
      </h1>

      <p
        class="description-text"
        data-cy="confirm-email-text">
        {{ "confirmEmailText" | i18n }}
      </p>

      <p
        class="description-text"
        data-cy="confirm-email-text-2"
        [innerHTML]="
          'confirmEmailText2' | i18n: { email: email || 'beispiel@domain.com' }
        "></p>

      <p
        class="description-text"
        data-cy="confirm-email-text-3">
        {{ "confirmEmailText3" | i18n }}
      </p>

      <p
        class="description-text"
        data-cy="confirm-email-text-4">
        {{ "confirmEmailText4" | i18n }}
      </p>
    </div>
  </ng-container>
</div>
